/* eslint-disable import/prefer-default-export */
import ContentType from '../enums/ContentType'
import * as AnalysisTypeGroup from '../enums/AnalysisTypeGroup'

/**
 * @param {string} analysis
 * @return {ContentType} contentType.
 */
export const getContentType = (analysis) => {
  let contentType

  if (AnalysisTypeGroup.SW.includes(analysis)) contentType = ContentType.SOCIAL_WEB
  else if (AnalysisTypeGroup.AM.includes(analysis)) contentType = ContentType.AUDIENCE_MARKETING

  return contentType
}
